export const createFilterHelpers = (categories) => {
  const emptyFilters = () =>
    categories.reduce((acc, { key }) => ({ ...acc, [key]: {} }), {});

  const cycleFilterValue = (filters, key, value) => {
    const current = { ...filters[key] };
    const state = current[value];
    const category = categories.find((c) => c.key === key);
    if (state === "include") {
      if (category?.excludable === false) {
        delete current[value];
      } else {
        current[value] = "exclude";
      }
    } else if (state === "exclude") {
      delete current[value];
    } else {
      current[value] = "include";
    }
    return { ...filters, [key]: current };
  };

  const itemMatchesFilters = (item, filters) =>
    categories.every(({ key, getValues }) => {
      const entries = Object.entries(filters[key] || {});
      if (entries.length === 0) return true;
      const itemValues = getValues(item);
      let hasInclude = false;
      let matchedInclude = false;
      for (const [value, state] of entries) {
        if (state === "exclude" && itemValues.includes(value)) return false;
        if (state === "include") {
          hasInclude = true;
          if (itemValues.includes(value)) matchedInclude = true;
        }
      }
      return !hasInclude || matchedInclude;
    });

  return { emptyFilters, cycleFilterValue, itemMatchesFilters };
};
